/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Mandatory/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckboxWithInputText from 'DesignSystem/TysiaCheckboxWithInputText/index'



/** @type {import('Simple/types.js').View} */
export default function Mandatory({
  children,
  viewPath = "/DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardWrite/Mandatory",
  onChange,
  isSubmitting
  
}) {
let txCardFieldDefinitionMandatoryValueData = fromData.useDataValue({ viewPath,
context: 'tx_card_field_definition',
path: 'mandatory',
})
let txCardFieldDefinitionMandatoryChangeData = fromData.useDataChange({ viewPath,
context: 'tx_card_field_definition',
path: 'mandatory',
})
let txCardFieldDefinitionMandatoryIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'tx_card_field_definition',
})
  return (<React.Fragment
>
<TysiaCheckboxWithInputText
  viewPath={`${viewPath}/TysiaCheckboxWithInputText`}
 text="Mandatory"
 data="tx_card_field_definition.mandatory"
 value={txCardFieldDefinitionMandatoryValueData}
 onChange={txCardFieldDefinitionMandatoryChangeData}
 disabled={txCardFieldDefinitionMandatoryIsSubmittingData}
/>
{children}
</React.Fragment>)
}